// Store Zustand per le notifiche in-app
import { create } from 'zustand'

export interface AppNotification {
  id: string
  type: 'info' | 'success' | 'warning' | 'error'
  title: string
  message?: string
  read: boolean
  createdAt: string
  link?: string
}

interface NotificationsState {
  notifications: AppNotification[]
  unreadCount: number
  isOpen: boolean
}

interface NotificationsActions {
  addNotification: (notification: Omit<AppNotification, 'read'>) => void
  markAsRead: (id: string) => void
  markAllAsRead: () => void
  removeNotification: (id: string) => void
  setNotifications: (notifications: AppNotification[]) => void
  setOpen: (open: boolean) => void
}

export const useNotificationsStore = create<NotificationsState & NotificationsActions>()(
  (set) => ({
    notifications: [],
    unreadCount: 0,
    isOpen: false,

    addNotification: (notification) =>
      set((state) => {
        const newNotification: AppNotification = { ...notification, read: false }
        const notifications = [newNotification, ...state.notifications].slice(0, 100)
        return {
          notifications,
          unreadCount: notifications.filter((n) => !n.read).length,
        }
      }),

    markAsRead: (id) =>
      set((state) => {
        const notifications = state.notifications.map((n) =>
          n.id === id ? { ...n, read: true } : n
        )
        return {
          notifications,
          unreadCount: notifications.filter((n) => !n.read).length,
        }
      }),

    markAllAsRead: () =>
      set((state) => ({
        notifications: state.notifications.map((n) => ({ ...n, read: true })),
        unreadCount: 0,
      })),

    removeNotification: (id) =>
      set((state) => {
        const notifications = state.notifications.filter((n) => n.id !== id)
        return {
          notifications,
          unreadCount: notifications.filter((n) => !n.read).length,
        }
      }),

    setNotifications: (notifications) => {
      // Guard difensivo: assicura che notifications sia sempre un array
      const safeNotifications = Array.isArray(notifications) ? notifications : []
      set({
        notifications: safeNotifications,
        unreadCount: safeNotifications.filter((n) => !n.read).length,
      })
    },

    setOpen: (open) => set({ isOpen: open }),
  })
)
